export default "__VITE_ASSET__BURYmUQP__"